import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  PlusCircle,
  Edit,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { getAllClients } from "../../core/api/settings";
import { setClients } from "../../core/redux/action";
import { getCurrentUser } from "../../core/api/settings";
import { getProfile } from "../../core/api/auth";


const Clients = ({ onAddNewClient, onEditClient }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const MySwal = withReactContent(Swal);
  const clients = useSelector((state) => state.clients);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  
  const loadClients = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAllClients();
      dispatch(setClients(response.data));
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [dispatch]);
  
  // Load clients on mount
  useEffect(() => {
    loadClients();
  }, [loadClients]);
  
  // Reload clients when navigating back to the clients page
  useEffect(() => {
    // Check if we're on the clients page
    if (location.pathname.includes("/settings/clients") && !location.pathname.includes("/add-client") && !location.pathname.includes("/edit-client")) {
      loadClients();
    }
  }, [location.pathname, loadClients]);

  const showConfirmationAlert = (clientId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setClients((prevClients) =>
          prevClients?.filter((client) => client.id !== clientId)
        );
        MySwal.fire({
          title: "Deleted!",
          text: "The client has been deleted.",
          icon: "success",
        });
      } else {
        MySwal.close();
      }
    });
  };
  const transformData = (clients) =>
    clients
      ?.map((client) => {
        if (client.brands.length === 0) {
          return {
            key: `${client.id}-no-brand`,
            company_name: client.company_name,
            logo: client.signed_logo,
            rowSpan: 1,
            brand_name: null,
            brand_website: null,
            address: null,
            action_client_id: client.id,
          };
        } else {
          return client.brands.map((brand, index) => ({
            key: `${client.id}-${brand.id}`,
            company_name: index === 0 ? client.company_name : "",
            logo: index === 0 ? client.signed_logo : "",
            rowSpan: index === 0 ? client.brands.length : 0,
            brand_name: brand.brand_name,
            brand_website: brand.brand_website,
            address: client.address,
            action_client_id: client.id,
          }));
        }
      })
      .flat();

  const columns = [
    {
      title: "Company",
      dataIndex: "company_name",
      render: (text, record) => {
        if (record.rowSpan === 0) {
          return null;
        }
        return (
          <span className="productimgname">
             
            <span
              className="clickable-link"
              onClick={() => {
                if (onEditClient) {
                  onEditClient(record.action_client_id);
                }
              }}
            >
              <u>{text}</u>
            </span>
          </span>
        );
      },
      onCell: (record) => ({
        rowSpan: record.rowSpan,
      }),
    },
    {
      title: "Brand",
      dataIndex: "brand_name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Brand Website",
      dataIndex: "brand_website",
      render: (text) =>
        text ? (
          <a
            className="clickable-link"
            href={text}
            target="_blank"
            rel="noopener noreferrer"
          >
            <u>{text}</u>
          </a>
        ) : (
          ""
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
      fixed: "right",
      render: (_, record) => {
        if (record.rowSpan === 0) {
          return null;
        }
        return (
          <div className="action-table-data">
            <div className="edit-delete-action">
              <span
                to="#"
                className="me-2 p-1"
                title="Edit"
                onClick={() => {
                  if (onEditClient) {
                    onEditClient(record.action_client_id);
                  }
                }}
              >
                <Edit className="feather-edit" size={15}/>
              </span>
              <Link
                hidden
                to="#"
                onClick={() => showConfirmationAlert(record.action_client_id)}
                className="p-2"
                title="Delete"
              >
                <Trash2 className="feather-trash-2" />
              </Link>
            </div>
          </div>
        );
      },
      onCell: (record) => ({
        rowSpan: record.rowSpan,
      }),
    },
  ];

    
  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Clients List</h4>
              <h6>Manage your clients</h6>
            </div>
          </div>
          <div className="page-btn">
            <Link
              to="#"
              className="btn btn-added"
              onClick={() => {
                if (onAddNewClient) {
                  onAddNewClient();
                }
              }}
            >
              <PlusCircle className="me-2 iconsize" />
              Add New Client
            </Link>
          </div>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
 

            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={transformData(clients)}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Clients;
